import './styles.scss';
import TopDashboardSection from '../../../common/top-dashboard-section';
import AlertMessages from '../../alert-messages';
import Card from '../../../common/card';
import l from '../../../../lang';
import ApiHero from './api-hero';
import ApiSolutions from './api-solutions';
import ApiKeysSection from './api-keys-section';

const ApiIntegrationPage = () => {
  return (
    <div className="api_integration_page">
      <TopDashboardSection
        title={l('paymentIntegration.api.page.title')}
        subtitle={l('paymentIntegration.api.page.subtitle')}
      />
      <AlertMessages />
      <Card className="api_integration_page__card api_integration_page__card--hero">
        <ApiHero />
      </Card>
      <Card className="api_integration_page__card">
        <ApiSolutions />
      </Card>
      <Card className="api_integration_page__card">
        <ApiKeysSection />
      </Card>
    </div>
  );
};

export default ApiIntegrationPage;
